<div *ngIf="reportType == 'unpaidOutstandingInDetails'">
  <div class="container" id="print-section">

    <table class="table table-bordered report-table">
      <thead>
        <tr>
          <th colspan="4" class="br-bottom br-right br-top small-text">हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक</th>
          <th colspan="3" class="br-bottom br-right br-top small-text">Advt. Outstanding Report</th>
          <th colspan="3" class="br-bottom br-right br-top small-text">
            दिनांक {{ currentDate | date: 'dd-MM-yyyy' }}
          </th>
        </tr>
        <tr>
          <th colspan="2" class="br-bottom br-right small-text"></th>
          <th colspan="3" class="br-bottom br-right small-text"> Unpaid Outstanding-In Details</th>
          <th colspan="5" class="br-bottom small-text">
            Date: From {{ startDate | date: 'dd-MM-yyyy' }} To {{ endDate | date: 'dd-MM-yyyy' }}
          </th>
        </tr>
        <tr>
          <th class="br-bottom br-right small-text">Invoice No</th>
          <th class="br-bottom br-right small-text">Invoice <br> Date</th>
          <th class="br-bottom br-right small-text">Advt Name</th>
          <th class="br-bottom br-right small-text">Cust Name</th> <!-- ✅ Added -->
          <th class="br-bottom br-right small-text">Contact <br> No</th>
          <th class="br-bottom br-right small-text">Issue Name</th>
          <th class="br-bottom br-right small-text">Issue<br>Date</th>
          <th class="br-bottom br-right small-text">Advt Amt</th>
          <th class="br-bottom br-right small-text">Received<br>Amount</th>
          <th class="br-bottom small-text">Unpaid<br>Amount</th>
        </tr>
      </thead>

      <tbody *ngFor="let data of onlyOutstandingInDetailFormBeans">
        <tr>
          <td colspan="10" class="br-bottom br-top bold-text off_rep_name ">Office Representative Name :
            <span class="ft-wt-200" style="font-weight: bold;font-size: 17px;">{{data.off_rep_name}} / {{data.office_rep_mob}}</span>
          </td>
        </tr>

        <ng-container *ngFor="let data1 of data.rep_data">
          <tr>
            <td colspan="10" class="br-bottom bold-text rep_name">Representative Name :
              <span class="ft-wt-200" style="font-weight: bold;font-size: 15px;">{{data1.rep_name}} / {{data1.rep_mob_no}} </span>
            </td>
          </tr>

          <tr *ngFor="let data2 of data1.advt_data">
            <td class="invoice-no">{{data2.advt_invoice_no}}</td>
            <td class="br-right">{{data2.advt_invoice_date}}</td>
            <td style="font-weight: bold;">{{data2.advt_name | slice:0:35}}</td>
            <td class="br-right" style="font-size: 14px;">{{data2.cust_name | slice:0:15}}</td> <!-- ✅ Added -->
            <td class="br-right" style="font-size: 14px;">{{data2.advt_mobile}}</td>
            <td class="br-right wrap-text" style="font-size: 14px;">{{data2.issue_name | slice:0:25}}</td>
            <td class="br-right" style="font-size: 14px;">{{data2.issue_date}}</td>
            <td class="br-right text-end advt-amt-col" style="text-align: right;font-weight: bold;font-size: 14px;">{{(data2.advt_amt * 1).toFixed(2)}}</td>
            <td class="br-right text-end net-amt-col" style="text-align: right;font-weight:bold;font-size: 14px;">{{(data2.net_amt * 1).toFixed(2)}}</td>
            <td class="text-end unpaid-amt-col" style="text-align: right;font-weight: bold;font-size: 14px;">{{(data2.unpaid_amt * 1).toFixed(2)}}</td>
          </tr>

          <tr>
            <td colspan="7" class="br-bottom br-top br-right bold-text" style="font-weight: bold;">Total: {{data1.rep_name}}</td>
            <td class="br-bottom br-top br-right text-end" style="font-weight: bold; text-align: right;font-size: 15px;">{{(data1.advt_amt_total * 1).toFixed(2)}}</td>
            <td class="br-bottom br-top br-right bold-text text-end" style="font-weight: bold; text-align: right;font-size: 15px;">{{(data1.net_amt_total * 1).toFixed(2)}}</td>
            <td class="br-bottom br-top bold-text text-end" style="font-weight: bold; text-align: right;font-size: 15px;">{{(data1.unpaid_amt_total * 1).toFixed(2)}}</td>
          </tr>
        </ng-container>
      </tbody>

      <tr>
        <td colspan="7" class="br-bottom br-top br-right bold-text">Total: Rs</td>
        <td class="br-bottom br-top br-right bold-text text-end" style="font-weight: bold; text-align: right;font-size: 15px; color: black;">{{(onlyOutStandingIDTotal * 1).toFixed(2)}}</td>
        <td class="br-bottom br-top br-right bold-text text-end" style="font-weight: bold; text-align: right;font-size: 15px; color: black;">{{(onlyOutStandingIDNetAmtTotal * 1).toFixed(2)}}</td>
        <td class="br-bottom br-top bold-text text-end" style="font-weight: bold; text-align: right;font-size: 15px; color: black;">{{(onlyOutStandingIDUnPaidTotal * 1).toFixed(2)}}</td>
      </tr>

      <tfoot></tfoot>
    </table>

    <div class="footer-line"></div>

    <div class="actions noPrint">
      <button mat-raised-button color="primary" (click)="exportExcel('Contract_InDetails_Report')">Export</button>

      <button mat-raised-button color="primary" printSectionId="print-section" [useExistingCss]="true" ngxPrint>
        Print
      </button>

      <button mat-button mat-dialog-close>Close</button>
    </div>
  </div>
</div>
